<template>
    <section class="gmp-section gmp-mb-l">
        <div class="highlights-module">
            <div class="h-c-page">
                <div class="h-c-grid highlights-module__sticky-wrapper">
                    <div class="h-c-grid__col h-c-grid__col-l--6">
                        <div class="highlights-module__sticky-el">
                            <img src="@/assets/img/sxgl2.png" class="gmp-no-grab highlights-module__image-desktop"
                                 alt="">
                        </div>
                    </div>

                    <div class="h-c-grid__col h-c-grid__col-l--5 highlights-module__content">
                        <h3 class="h-c-headline h-c-headline--one h-has-bottom-margin">
                            企业可实现
                        </h3>
                        <p></p>
                        <picture>
                            <img src="@/assets/img/sxgl2.png" alt=""
                                 class="gmp-no-grab highlights-module__image-mobile">
                        </picture>

                        <div class="highlights-module__listing">
                            <ul class="highlights-module__highlights">

                                <li class="highlights-module__highlight">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four h-has-bottom-margin">
                                        统一管理
                                    </h4>
                                    <p>该系统通过集中管理各个分店的采购、库存和成本核算，帮助连锁餐饮公司统一标准和流程，确保各门店的操作一致性，提高整个连锁的管理效率。</p>
                                </li>
                                <li class="highlights-module__highlight">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four h-has-bottom-margin">
                                        成本控制
                                    </h4>
                                    <p>系统能够实时监控和分析各门店的成本数据，包括采购成本、库存持有成本和食材浪费情况，从而帮助企业优化成本结构，提升出品率，降低浪费。</p>
                                </li>
                                <li class="highlights-module__highlight">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four h-has-bottom-margin">
                                        提升采购效率
                                    </h4>
                                    <p>通过集中采购端，公司能够集中处理所有门店的采购需求，与供应商进行大规模的价格谈判，获取更优惠的价格和更高质量的食材，同时减少采购过程中的重复劳动和错误。</p>
                                </li>
                                <li class="highlights-module__highlight">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four h-has-bottom-margin">
                                        实时数据分析
                                    </h4>
                                    <p>系统提供的实时数据分析功能可以让管理层快速掌握门店运营情况，如销售趋势、库存水平和成本变动，从而快速做出决策，调整运营策略，提高响应市场变化的能力。</p>
                                </li>

                                <!--                                <li class="highlights-module__highlight">-->
                                <!--                                    <picture>-->
                                <!--                                        <img src="@/assets/img/1a.png" alt=""-->
                                <!--                                             class="gmp-circle-icon gmp-circle-icon&#45;&#45;yellow highlights-module__icon">-->
                                <!--                                    </picture>-->
                                <!--                                    <h4 class="h-c-headline h-c-headline&#45;&#45;four h-has-bottom-margin">-->
                                <!--                                        优化库存管理-->
                                <!--                                    </h4>-->
                                <!--                                    <p>库房端的功能可以有效管理库存的出入库记录，减少过量库存和库存积压，确保库存的高周转率和低损耗，避免资金被不必要地占用。</p>-->
                                <!--                                </li>-->
                                <!--                                <li class="highlights-module__highlight">-->
                                <!--                                    <picture>-->
                                <!--                                        <img src="@/assets/img/1a.png" alt=""-->
                                <!--                                             class="gmp-circle-icon gmp-circle-icon&#45;&#45;yellow highlights-module__icon">-->
                                <!--                                    </picture>-->
                                <!--                                    <h4 class="h-c-headline h-c-headline&#45;&#45;four h-has-bottom-margin">-->
                                <!--                                        规范化操作-->
                                <!--                                    </h4>-->
                                <!--                                    <p>中央厨房端使得食材加工和准备工作可以在中央厨房集中进行，然后分配到各个门店，这样可以标准化食品的质量和口味，减少分店之间的差异。</p>-->
                                <!--                                </li>-->
                                <!--                                <li class="highlights-module__highlight">-->
                                <!--                                    <picture>-->
                                <!--                                        <img src="@/assets/img/1a.png" alt=""-->
                                <!--                                             class="gmp-circle-icon gmp-circle-icon&#45;&#45;yellow highlights-module__icon">-->
                                <!--                                    </picture>-->
                                <!--                                    <h4 class="h-c-headline h-c-headline&#45;&#45;four h-has-bottom-margin">-->
                                <!--                                        增强透明度-->
                                <!--                                    </h4>-->
                                <!--                                    <p>整个系统的使用增加了业务流程的透明度，管理层可以随时查看各个环节的操作详情，有效监控和预防潜在的风险和错误。-->

                                <!--                                    </p>-->
                                <!--                                </li>-->

                            </ul>
<!--                            <ul class="highlights-module__highlights">-->

<!--                                <li class="highlights-module__highlight">-->
<!--                                    <picture>-->
<!--                                        <img src="@/assets/img/1a.png" alt=""-->
<!--                                             class="gmp-circle-icon gmp-circle-icon&#45;&#45;yellow highlights-module__icon">-->
<!--                                    </picture>-->
<!--                                    <h4 class="h-c-headline h-c-headline&#45;&#45;four h-has-bottom-margin">-->
<!--                                        集中化管理-->
<!--                                    </h4>-->
<!--                                    <p>直营企业通常有多个门店和中央厨房，系统提供的各个小程序可以实现对所有门店的统一管理。无论是采购还是成本核算，都可以通过“门店管理端”和“中央厨房端”集中监控和控制，减少管理复杂性和成本。</p>-->
<!--                                </li>-->
<!--                                <li class="highlights-module__highlight">-->
<!--                                    <picture>-->
<!--                                        <img src="@/assets/img/1a.png" alt=""-->
<!--                                             class="gmp-circle-icon gmp-circle-icon&#45;&#45;yellow highlights-module__icon">-->
<!--                                    </picture>-->
<!--                                    <h4 class="h-c-headline h-c-headline&#45;&#45;four h-has-bottom-margin">-->
<!--                                        成本控制与优化-->
<!--                                    </h4>-->
<!--                                    <p>通过系统的精准数据分析，直营企业可以优化采购流程，减少浪费和过多库存。集中采购和出品率的管理功能可以帮助企业实现规模效应，进一步降低采购成本，提高利润率。</p>-->
<!--                                </li>-->
<!--                                <li class="highlights-module__highlight">-->
<!--                                    <picture>-->
<!--                                        <img src="@/assets/img/1a.png" alt=""-->
<!--                                             class="gmp-circle-icon gmp-circle-icon&#45;&#45;yellow highlights-module__icon">-->
<!--                                    </picture>-->
<!--                                    <h4 class="h-c-headline h-c-headline&#45;&#45;four h-has-bottom-margin">-->
<!--                                        品质一致性-->
<!--                                    </h4>-->
<!--                                    <p>直营企业需要在多个门店中保持产品品质的一致性。系统的“时鲜管理端”可以实时监控原材料的品质，确保每个门店提供的食材新鲜如一，提高客户满意度和品牌口碑。</p>-->
<!--                                </li>-->
<!--                                <li class="highlights-module__highlight">-->
<!--                                    <picture>-->
<!--                                        <img src="@/assets/img/1a.png" alt=""-->
<!--                                             class="gmp-circle-icon gmp-circle-icon&#45;&#45;yellow highlights-module__icon">-->
<!--                                    </picture>-->
<!--                                    <h4 class="h-c-headline h-c-headline&#45;&#45;four h-has-bottom-margin">-->
<!--                                        高效运营-->
<!--                                    </h4>-->
<!--                                    <p>由于直营企业的业务规模较大，系统的自动化管理功能可以显著提高运营效率，减少人工操作的错误率，使管理层能够更好地集中精力于战略决策和市场拓展。</p>-->
<!--                                </li>-->

<!--                            </ul>-->
                        </div>
                    </div>

                </div>


                <div class="highlights-module__carousel highlights-module__carousel--horizontal">

                    <div class="glue-pagination h-c-carousel h-c-carousel--simple ng-isolate-scope glue-o-pagination">

                        <div class="h-c-carousel__wrap ng-scope">
                            <ul class="glue-carousel glue-is-ready" id="highlightsUl"
                                style="width: auto; transform: none">
                                <li class="h-c-carousel__item">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four highlights-module__subhead">
                                        统一管理
                                    </h4>
                                    <div class="highlights-module__description">
                                        <p>该系统通过集中管理各个分店的采购、库存和成本核算，帮助连锁餐饮公司统一标准和流程，确保各门店的操作一致性，提高整个连锁的管理效率。。</p>
                                    </div>

                                </li>
                                <li class="h-c-carousel__item">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four highlights-module__subhead">
                                        成本控制
                                    </h4>
                                    <div class="highlights-module__description">
                                        <p>系统能够实时监控和分析各门店的成本数据，包括采购成本、库存持有成本和食材浪费情况，从而帮助企业优化成本结构，提升出品率，降低浪费。</p>
                                    </div>

                                </li>
                                <li class="h-c-carousel__item">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four highlights-module__subhead">
                                        提升采购效率
                                    </h4>
                                    <div class="highlights-module__description">
                                        <p>通过集中采购端，公司能够集中处理所有门店的采购需求，与供应商进行大规模的价格谈判，获取更优惠的价格和更高质量的食材，同时减少采购过程中的重复劳动和错误。</p>
                                    </div>

                                </li>
                                <li class="h-c-carousel__item">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four highlights-module__subhead">
                                        实时数据分析
                                    </h4>
                                    <div class="highlights-module__description">
                                        <p>系统提供的实时数据分析功能可以让管理层快速掌握门店运营情况，如销售趋势、库存水平和成本变动，从而快速做出决策，调整运营策略，提高响应市场变化的能力。</p>
                                    </div>

                                </li>

                            </ul>
                        </div>

                        <div class="h-c-carousel__navigation product-card-grid__navigation ng-scope">
                            <ul class="glue-pagination-page-list ng-isolate-scope glue-o-pagination__page-list">
                                <li :class="{active:0 === activeIndex}"
                                    class=" glue-o-pagination__button-container  glue-o-pagination__page-list-button-container ng-scope "
                                    @click="showIndex(0)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"></button>
                                </li>
                                <li :class="{active:1 === activeIndex}"
                                    class="glue-o-pagination__button-container glue-o-pagination__page-list-button-container ng-scope"
                                    @click="showIndex(1)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"></button>
                                </li>
                                <li :class="{active:2 === activeIndex}"
                                    class="glue-o-pagination__button-container glue-o-pagination__page-list-button-container ng-scope"
                                    @click="showIndex(2)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"
                                    ></button>
                                </li>
                                <li :class="{active:3 === activeIndex}"
                                    class="glue-o-pagination__button-container glue-o-pagination__page-list-button-container ng-scope"
                                    @click="showIndex(3)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"
                                    ></button>
                                </li>



                                <div style="clear:both;"></div>

                            </ul>

                        </div>

                    </div>



                </div>

            </div>

        </div>

    </section>
</template>

<script>
    export default {
        name: "Enter_highLights",
        props: ['clientWidth'],
        data() {
            return {
                activeIndex: 0,
                itemWidth: ""
            }
        },

        watch: {
            clientWidth: function (val) {
                this.clientWidth = val
                this.changeFixed(this.clientWidth)
            },
        },


        methods: {
            showIndex(data) {
                // var itemWidth = this.$('.h-c-carousel__item').width();


                if(this.clientWidth < 600){
                    var itemWidth1 = this.$('.h-c-carousel').width();
                    var moveWidth1 = "";

                    moveWidth1 = - + data * itemWidth1;
                    console.log("1=====" + moveWidth1)
                    moveWidth1 = Number(moveWidth1) + Number(20)
                    console.log("2======" + moveWidth1);
                    this.$('#highlightsUl').css({
                        "transform": "translate3d(" + moveWidth1 + "px, 0px, 0px)",
                        "transition": "transform .4s"
                    })
                }else{
                    var itemWidth = this.$('.h-c-carousel').width();
                    var moveWidth = "";
                    moveWidth = - + data * itemWidth;
                    moveWidth = Number(moveWidth);
                    this.$('#highlightsUl').css({
                        "transform": "translate3d(" + moveWidth + "px, 0px, 0px)",
                        "transition": "transform .4s"
                    })
                }

                this.activeIndex = data;
            },


            changeFixed(data) {
                this.activeIndex = 0;
                var itemWidth = this.$('.h-c-carousel').width();
                var items = this.$('.h-c-carousel__item');
                var how = this.clientWidth * 5;
                for (var j = 0; j < items.length; j++) {
                    this.$(items[j]).css({
                        'width': itemWidth + 'px',
                        "min-width": "149px"
                    })
                }
                if (data < 1024) {
                    if (data < 600) {

                        if (this.activeIndex === 0) {
                            this.$('#highlightsUl').css({
                                'width': how + 'px',
                                "transform": "translate3d(20px, 0px,0px)",
                            })
                        } else {
                            var how1 = (Number(this.clientWidth) - Number(20)) * 5;
                            console.log("dayu600 < 1024")
                            this.$('#highlightsUl').css({
                                'width': how1 + 'px',
                                "transform": "translate3d(20px, 0px,0px)",
                            })
                        }

                    } else{
                        this.$('#highlightsUl').css({
                            'width': how + 'px',
                            "transform": "translate3d(0px, 0px,0px)",
                        })

                    }


                } else {
                    this.$('#highlightsUl').css({
                        'width': "auto",
                        "transform": "translate3d(0px, 0px,0px)",
                    })
                }
            },
        }


    }
</script>

<style lang="less">



</style>